var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.publicUrl)?_c('li',[_c('span',{on:{"click":_vm.onPublish}},[_vm._v("Share Project")])]):(_vm.publicUrl)?_c('li',{staticClass:"slot"},[_c('span',[_c('a',{attrs:{"href":_vm.getPublicUrl(),"target":"_blank"}},[_vm._v("View Shared Project")])]),_c('span',{on:{"click":_vm.onUnpublish}},[_vm._v("Revert to Private")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }